var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18265",
    "data-name": "Path 18265",
    d: "M13.4,6a2.4,2.4,0,0,1,2.4,2.4V19.013l5.035,2.909a2.4,2.4,0,0,1-2.4,4.157l-6.235-3.6A2.411,2.411,0,0,1,11,20.4V8.4A2.4,2.4,0,0,1,13.4,6Z",
    transform: "translate(12.6 5.6)",
    fill: "#85e6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18266",
    "data-name": "Path 18266",
    d: "M2,26A24,24,0,1,0,9.029,9.029,24,24,0,0,0,2,26ZM23.6,14a2.4,2.4,0,0,1,4.8,0V24.613l5.035,2.909a2.4,2.4,0,0,1-2.4,4.157l-6.235-3.6A2.411,2.411,0,0,1,23.6,26Z",
    fill: "#c2f2e1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.f9f39647e877b6265821590454cfd684.svg";
export { ForwardRef as ReactComponent };